import React from 'react'
import { Horizontal, Vertical, Texto, addCommasToNumber } from '@gravitate-js/excalibrr'
import { IntradayProgressBar } from '../IntradayProgressBar'
import { DirectiveOrders } from './DirectiveOrders'
import { SelectedDirectiveDetails } from './SelectedDirectiveDetails'
import { useDirectiveContext } from '@components/Reports/DispatchDirective/DirectiveContext'
import { SelectedPriceDetails } from './SelectedPriceDetails'
import { HourlyChart } from './HourlyChart'
import { useDirectiveOrders } from './useOrderVolume'
export const SelectedStatus = ({ showModal }) => {
  const { selectedDirective, selectedPrice } = useDirectiveContext()
  const { unfilteredOrders, ordersLoading, chartData } = useDirectiveOrders()

  return (
    <>
      {selectedPrice ? (
        <SelectedPriceDetails selectedDirective={selectedDirective} selectedPrice={selectedPrice} />
      ) : (
        <SelectedDirectiveDetails selectedDirective={selectedDirective} />
      )}
      <VolumeStatus selectedDirective={selectedDirective} selectedPrice={selectedPrice} />
      <HourlyChart chartType='intraday' ordersLoading={ordersLoading} chartData={chartData} />
      <DirectiveOrders showModal={showModal} unfilteredOrders={unfilteredOrders} ordersLoading={ordersLoading} />
    </>
  )
}
const VolumeStatus = ({ selectedDirective }) => {
  const { viewingPlanned } = useDirectiveContext()
  return (
    <Vertical flex={1} border='all' borderRadius={3} background='bg-2' className='mb-3 px-4 py-3'>
      <Texto appearance='medium' weight='bold'>
        INTRADAY VOLUME STATUS
      </Texto>
      <Horizontal verticalCenter className='pr-3 pt-2' flex={1}>
        <IntradayProgressBar directive={selectedDirective} showPlanned={viewingPlanned} />
      </Horizontal>
      <Horizontal>
        <Vertical verticalCenter flex={2}>
          <Horizontal>
            <Vertical verticalCenter style={{ maxWidth: 30 }}>
              <div
                className='mx-3'
                style={{ width: 10, height: 10, borderRadius: 20, background: 'var(--theme-color-1)' }}
              />
            </Vertical>
            <Vertical>
              <Texto weight={600} appearance='medium'>
                Total Loaded
              </Texto>
              <Texto weight='bold' category='h4' appearance='primary'>
                {addCommasToNumber(selectedDirective.loaded, 0)}
              </Texto>
            </Vertical>
          </Horizontal>
        </Vertical>
        <Vertical verticalCenter flex={2}>
          <Horizontal>
            <Vertical verticalCenter style={{ maxWidth: 30 }}>
              <div
                className='mx-3'
                style={{ width: 10, height: 10, borderRadius: 20, background: 'var(--theme-color-4)' }}
              />
            </Vertical>
            <Vertical>
              <Texto weight={600} appearance='medium'>
                Carrier
              </Texto>
              <Texto weight={600} category='h4' style={{ color: 'var(--theme-color-4)' }}>
                {addCommasToNumber(selectedDirective.carrier, 0)}
              </Texto>
            </Vertical>
          </Horizontal>
        </Vertical>
        <Vertical verticalCenter flex={2}>
          <Horizontal>
            <Vertical verticalCenter style={{ maxWidth: 30 }}>
              <div
                className='mx-3'
                style={{ width: 10, height: 10, borderRadius: 20, background: 'var(--theme-color-2)' }}
              />
            </Vertical>
            <Vertical>
              <Texto weight={600} appearance='medium'>
                Scheduled
              </Texto>
              <Texto weight={600} category='h4' appearance='secondary'>
                {addCommasToNumber(selectedDirective.scheduled, 0)}
              </Texto>
            </Vertical>
          </Horizontal>
        </Vertical>
        {viewingPlanned && (
          <Vertical verticalCenter flex={2}>
            <Horizontal>
              <Vertical verticalCenter style={{ maxWidth: 30 }}>
                <div
                  className='mx-3'
                  style={{
                    width: 10,
                    height: 10,
                    borderRadius: 20,
                    background:
                      'repeating-linear-gradient(45deg,var(--theme-info), var(--theme-info) 2px, var(--gray-100) 2px, var(--gray-100) 4px)',
                  }}
                />
              </Vertical>

              <Vertical>
                <Texto weight={600} appearance='medium'>
                  Planned
                </Texto>
                <Texto weight={600} category='h4' appearance='medium'>
                  {addCommasToNumber(selectedDirective.planned, 0)}
                </Texto>
              </Vertical>
            </Horizontal>
          </Vertical>
        )}
        <Vertical flex={1} verticalCenter>
          <div className='mx-3' style={{ width: 2, height: 25, background: 'var(--gray-300)' }} />
        </Vertical>
        <Vertical flex={2}>
          <Texto weight={600} appearance='medium'>
            Directive Min
          </Texto>
          <Texto
            weight={selectedDirective.directive_min ? 'bold' : 500}
            appearance={selectedDirective.directive_min ? 'default' : 'medium'}
            category='h3'
          >
            {selectedDirective?.directive_min || selectedDirective?.directive_min === 0
              ? addCommasToNumber(selectedDirective.directive_min, 0)
              : 'Not Set'}
          </Texto>
        </Vertical>
        <Vertical flex={2}>
          <Texto weight={600} appearance='medium'>
            Directive Max
          </Texto>
          <Texto
            weight={selectedDirective.directive_max ? 'bold' : 500}
            appearance={selectedDirective.directive_max ? 'default' : 'medium'}
            category='h3'
          >
            {selectedDirective?.directive_max || selectedDirective?.directive_max === 0
              ? addCommasToNumber(selectedDirective?.directive_max, 0)
              : 'Not Set'}
          </Texto>
        </Vertical>
      </Horizontal>
    </Vertical>
  )
}
